import { render, staticRenderFns } from "./TransactionDetailsComponent.vue?vue&type=template&id=238b221d&scoped=true"
import script from "./TransactionDetailsComponent.vue?vue&type=script&lang=js"
export * from "./TransactionDetailsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b221d",
  null
  
)

export default component.exports